module.exports = __webpack_public_path__ + "static/img/fzzx.40496c80.jpg";